export default {
    namespaced: true,
    state: {
        placeholder:"聚焦搜索这座天空之城",
        blogSearchKeyword:"",
        blogDetailSearchKeyword:"",
        messageSearchKeyword:"",
        createManageSearchKeyword:"",
        momentSearchKeyword:"",
        toolSearchKeyword:"",
        search:false
    },
    mutations: {
        placeholder(state, value) {
            state.placeholder = value;
        },
        blogSearchKeyword(state,val){
            state.blogSearchKeyword = val
        },
        messageSearchKeyword(state,val){
            state.messageSearchKeyword = val
        },
        createManageSearchKeyword(state,val){
            state.createManageSearchKeyword = val
        },
        momentSearchKeyword(state,val){
            state.momentSearchKeyword = val
        },
        blogDetailSearchKeyword(state,val){
            state.blogDetailSearchKeyword = val
        },
        toolSearchKeyword(state,val){
            state.toolSearchKeyword = val
        },
        search(state, value){
            state.search = value;
        }
    }
}